/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BackupDto } from '../models/BackupDto';
import type { BackupHistoryDto } from '../models/BackupHistoryDto';
import type { ScheduledBackupDto } from '../models/ScheduledBackupDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBackupControllerService {

    /**
     * @param name
     * @returns ScheduledBackupDto OK
     * @throws ApiError
     */
    public static getParticipantBackupSchedule(
        name: string,
    ): CancelablePromise<ScheduledBackupDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/backup',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns ScheduledBackupDto Created
     * @throws ApiError
     */
    public static createParticipantBackupSchedule(
        name: string,
        requestBody: BackupDto,
    ): CancelablePromise<ScheduledBackupDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participants/{name}/backup',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteParticipantBackupSchedule(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/participants/{name}/backup',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns BackupHistoryDto OK
     * @throws ApiError
     */
    public static getParticipantBackupHistory(
        name: string,
    ): CancelablePromise<Array<BackupHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/backup/history',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
